import {
  SET_VIRTUALDEVICE_TIMER,
  SET_VIRTUALDEVICE_BINDSTATUS,
  SET_CONSOLEOUTPUT,
  SET_VIRTUALDEVICE_WS,
  SET_VIRTUALDEVICE_FEATUREVALUES,
} from '../actions/virtualDevice';

const defVal = {
  // 轮询定时器
  virtualDeviceCheckTimer: 0,
  // 当前扫码状态 0 未扫码 1 已扫码 
  // 实际由服务端接口确定，APP扫码后服务端有一个过期时间，达到过期时间需要重新扫码接口才会返回绑定关系
  bindStatus: 0,
  // 控制台输出
  consoleOutput: [],
  // ws长连接
  ws: null,
  // 心跳任务
  interval: '',
  // 序列号
  devSerial: '',
  // 功能点值
  featureValues: {},

};

export default (state = defVal, action) => {
  switch (action.type) {
    case SET_VIRTUALDEVICE_TIMER:
      return Object.assign({}, state, {
        virtualDeviceCheckTimer: action.virtualDeviceCheckTimer,
      });
    case SET_VIRTUALDEVICE_BINDSTATUS:
      return Object.assign({}, state, {
        bindStatus: action.bindStatus,
      });
    case SET_CONSOLEOUTPUT:
      return Object.assign({}, state, {
        consoleOutput: action.consoleOutput,
      });
    case SET_VIRTUALDEVICE_WS:
      return Object.assign({}, state, {
        ws: action.ws,
        devSerial: action.devSerial,
        interval: action.interval,
      });
    case SET_VIRTUALDEVICE_FEATUREVALUES:
      return Object.assign({}, state, {
        featureValues: action.featureValues,
      });

    default:
      return state;
  }
};
